import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconCards = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "20"}
    height={props.height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 3.33154H13.3333C13.5543 3.33154 13.7663 3.41934 13.9226 3.57562C14.0789 3.7319 14.1666 3.94386 14.1666 4.16488V7.08154M16.6666 4.99821C16.8866 5.09154 17.1 5.17904 17.3066 5.26071C17.5101 5.34703 17.6709 5.51062 17.7537 5.7155C17.8365 5.92038 17.8346 6.14976 17.7483 6.35321L15.8333 10.8315M3.00332 5.99571L8.95165 3.40488C9.0498 3.36281 9.15539 3.34081 9.26218 3.34019C9.36896 3.33958 9.47479 3.36034 9.57343 3.40127C9.67207 3.4422 9.76151 3.50247 9.83648 3.57851C9.91146 3.65455 9.97045 3.74484 10.01 3.84404L14.1133 13.7624C14.1986 13.9635 14.2015 14.1901 14.1214 14.3933C14.0413 14.5966 13.8846 14.7602 13.685 14.849L7.73748 17.4399C7.63928 17.4821 7.53362 17.5042 7.42674 17.5049C7.31986 17.5055 7.21393 17.4848 7.1152 17.4439C7.01646 17.4029 6.92694 17.3426 6.8519 17.2665C6.77686 17.1904 6.71784 17.1 6.67832 17.0007L2.57498 7.08154C2.48969 6.88042 2.48679 6.65385 2.5669 6.45061C2.64702 6.24737 2.80373 6.08454 3.00332 5.99571Z"
      stroke={props.color || colors.secondaryAction.default}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCards;
